import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import QuickJump from "components/cmdk/QuickJump";
import routes from "routes.js";
import Cookies from "js-cookie";
import { getUser } from "utils/utils";

export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Operations");
  const [user, setUser] = React.useState(null);
  const [userLoaded, setUserLoaded] = React.useState(false);

  React.useEffect(() => {
    const fetchUser = async () => {
      try {
        const current = await getUser();
        setUser(current);
      } finally {
        setUserLoaded(true);
      }
    };
    fetchUser();
  }, []);

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);

  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  React.useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      window.location.href = "/auth/sign-in";
    }
  }, []);

  const getActiveRoute = (routes) => {
    let activeRoute = "Operations";
    for (let i = 0; i < routes.length; i++) {
      if (
        routes[i] &&
        routes[i].layout &&
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
      }
    }
    return activeRoute;
  };

  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        routes[i] &&
        routes[i].layout &&
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (!prop || prop.layout !== "/admin") return null;
      if (prop.superAdminOnly && !user?.superAdmin) return null;
      if (
        !user?.superAdmin &&
        user?.enabledDashboardPaths &&
        user.enabledDashboardPaths.length > 0 &&
        !user.enabledDashboardPaths.includes(prop.path)
      )
        return null;
      return (
        <Route path={`/${prop.path}`} element={prop.component} key={key} />
      );
    });
  };

  const defaultPath = "/admin/operations";
  const defaultRoute = userLoaded ? <Navigate to={defaultPath} replace /> : null;

  return (
    <div className="flex h-full w-full" dir="rtl">
      <Sidebar open={open} onClose={() => setOpen(false)} user={user} />
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        <main className="mx-[12px] h-full flex-none transition-all md:pe-2 xl:ms-72">
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"Moqawel Dashboard"}
              brandText={currentRoute}
              secondary={getActiveNavbar(routes)}
              {...rest}
            />
            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pe-2">
              <Routes>
                {getRoutes(routes)}
                <Route
                  path="/"
                  element={defaultRoute}
                />
                <Route
                  path="default"
                  element={defaultRoute}
                />
              </Routes>
            </div>
          </div>
        </main>
      </div>
      <QuickJump routes={routes} />
    </div>
  );
}
